/**
 * ratesFilterFields.js
 *
 * Advanced filter field catalog for the Rates grid. Field keys and operators match
 * RateDynamicSpecification.java's leaf handling on the backend field-for-field.
 *
 * Note: Rate's boolean flags (isContracted/isRepresentative) are supported by the backend
 * Specification but deliberately left out of this catalog -- see routesFilterFields.js's note
 * on the same limitation (no boolean-toggle value editor in the shared AdvancedFilterModal yet).
 */

const TEXT_OPS = ["CONTAINS", "EQ"];
const DATE_OPS = ["GTE", "LTE", "EQ"];
const NUMBER_OPS = ["GTE", "LTE", "EQ"];

export const RATE_TYPE_OPTIONS = ["BASE", "FSC", "ACCESSORIAL"];
export const RATE_BASIS_OPTIONS = ["FLAT", "PER_MILE", "PER_CWT", "PER_OCCURRENCE", "PERCENTAGE"];

export const RATE_RULE_FIELDS = [
  {
    key: "rateCode", label: "Rate Code", type: "text", group: "Rate",
    ops: TEXT_OPS, backendField: "rateCode", placeholder: "e.g. RATE-00123",
  },
  {
    key: "officeCode", label: "Office Code", type: "text", group: "Rate",
    ops: TEXT_OPS, backendField: "officeCode", placeholder: "e.g. DIAMOND-MET",
  },
  {
    key: "routeCode", label: "Route Code", type: "text", group: "Rate",
    ops: TEXT_OPS, backendField: "routeCode",
  },
  {
    key: "laneCode", label: "Lane Code", type: "text", group: "Rate",
    ops: TEXT_OPS, backendField: "laneCode",
  },
  {
    key: "contractCode", label: "Contract Code", type: "text", group: "Rate",
    ops: TEXT_OPS, backendField: "contractCode",
  },
  {
    key: "rateType", label: "Charge Code", type: "select", group: "Rate",
    options: RATE_TYPE_OPTIONS, ops: ["EQ", "NEQ", "IN"], backendField: "rateType",
  },
  {
    key: "rateBasis", label: "Rate Basis", type: "select", group: "Rate",
    options: RATE_BASIS_OPTIONS, ops: ["EQ", "NEQ", "IN"], backendField: "rateBasis",
  },
  { key: "equipment", label: "Equipment", type: "text", group: "Rate", ops: TEXT_OPS, backendField: "equipment" },

  { key: "carrier", label: "Carrier", type: "text", group: "Parties", ops: TEXT_OPS, backendField: "carrier" },
  { key: "shipper", label: "Shipper", type: "text", group: "Parties", ops: TEXT_OPS, backendField: "shipper" },
  { key: "carrierCode", label: "Carrier Code", type: "text", group: "Parties", ops: TEXT_OPS, backendField: "carrierCode" },
  { key: "shipperCode", label: "Shipper Code", type: "text", group: "Parties", ops: TEXT_OPS, backendField: "shipperCode" },

  { key: "cost", label: "Cost", type: "number", group: "Amounts", ops: NUMBER_OPS, backendField: "cost" },

  { key: "startDate", label: "Start Date", type: "date", group: "Dates", ops: DATE_OPS, backendField: "startDate" },
  { key: "endDate", label: "End Date", type: "date", group: "Dates", ops: DATE_OPS, backendField: "endDate" },
];
